import React from "react";

import { Typography } from "@mui/material";

interface Props {
  children: React.ReactNode;
}

export const SectionLabel: React.FC<Props> = ({ children }) => {
  return (
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 700,
        color: "#6B7280",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        mb: 1
      }}
    >
      {children}
    </Typography>
  );
};
